exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#app-header {\n  background-color: #ffffff;\n  border: 1px solid #eeeeee;\n  height: 100px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/tretapey/Documents/Programmer/craCSS/DOC-in/src/app/header/header.component.scss
// module id = ../../../../../src/app/header/header.component.scss
// module chunks = 1